export default "__VITE_ASSET__bde01f53__"